$(function () {
    initReplyTextarea();
});

function initReplyTextarea(el) {
    if(el != null){
        $('.keyconfirm-reply', el).keyconfirm({
            onConfirm: function (el, e) {
                send_reply(el, e);
            }
        });
    } else {
        $('.keyconfirm-reply').keyconfirm({
            onConfirm: function (el, e) {
                send_reply(el, e);
            }
        });
    }
}

function send_reply(el, e) {
    e.preventDefault();
    
    var form = $(el).parents('form');

    $('textarea[name="message"]', form).attr('disabled', true);

    $.post("/post/reply",
        {
            '_token': $('input[name="_token"]', form).val(),
            '_post_id': $('input[name="_post_id"]', form).val(),
            'message': $('textarea[name="message"]', form).val(),
        },
        function (response) {

            $('textarea[name="message"]', form).val('').attr('disabled', false);

            if (response.success == false) {
                systemalert(response.message, 'warning');
            }

        }.bind(this),
        'json'
    )
        .fail(function () {
            $('textarea[name="message"]', form).attr('disabled', false);
            systemalert('There was an system error, please notify an admin!', 'danger');
        })

}